import GuidUtils from '@/shared/utils/guid'

export default class Modality {
  constructor({
    id,
    name
  } = {}) {
    this.id = id || GuidUtils.emptyGuid,
    this.name = name
  }
}